module.exports = __webpack_public_path__ + "static/5star-reveal-5b4d63bc627879ac4945455ae78c50fb.mp3";